module.exports = __webpack_public_path__ + "img/1.edd4a52d.png";